module.exports = __webpack_public_path__ + "img/3-1.21829978.png";